import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useTheme } from "@mui/material";

interface Props {
  top_employee: null | any[];
}

const TopTimesheetChart = (props: Props) => {
  const [employeesNames, setEmployeesNames] = useState<string[]>();
  const [workedMinutes, setWorkedMinutes] = useState<string[]>();

  const theme = useTheme();

  useEffect(() => {
    let usernames: any = [];
    let minutes: any = [];

    if (props.top_employee) {
      props.top_employee.forEach((item) => {
        usernames.push(item.name);
        minutes.push(item.count);
      });

      setEmployeesNames(usernames);
      setWorkedMinutes(minutes);
    }
  }, [props.top_employee]);

  let options = {
    chart: {
      type: "column",
      backgroundColor: theme?.palette?.background?.paper,
    },
    accessibility: {
      description: "Top Employees details",
    },
    title: {
      text: "Timesheet count",
      style: {
        color: theme?.palette?.text?.secondary,
      },
    },
    // subtitle: {
    //   text:
    //     'Source: <a href="https://fas.org/issues/nuclear-weapons/status-world-nuclear-forces/" ' +
    //     'target="_blank">FAS</a>'
    // },
    xAxis: {
      // allowDecimals: false,
      categories: employeesNames,
      gridLineWidth: 0,
      style: {
        color: theme?.palette?.text?.secondary,
      },
      // labels: {
      //   formatter: function () {
      //     console.log(this, "this value");
      //     return this.value;
      //   }
      // },
      // accessibility: {
      //   rangeDescription: "Range: 2021 to 2022."
      // }
    },
    yAxis: {
      title: {
        text: "Number of times record in timesheet",
      },
      borderWidth: 20,
      gridLineWidth: 0,

      // labels: {
      //   formatter: function () {
      //     return this.value;
      //   },
      // },
    },
    tooltip: {
      // pointFormat: "{series.name} <b> in {point.x} by {point.y:,.0f}</b><br/> ",
      pointFormat: " <b>{point.y:,.0f}</b> times<br/> ",
    },
    plotOptions: {
      area: {
        borderWidth: "20",

        pointStart: 0,

        color: "rgb(207,232,252)",
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    series: [
      {
        name: "Employees",
        data: workedMinutes,
      },
    ],
  };
  return (
    <div className="chart_container">
      <div className="subject_chart_container">
        <HighchartsReact
          className="chart"
          highcharts={Highcharts}
          options={options}
        />
      </div>
    </div>
  );
};

export default TopTimesheetChart;
